import { Add } from "@mui/icons-material";
import { IconButton, ThemeProvider } from "@mui/material";
import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import Loading from "../../../components/layouts/Loading";
import Page from "../../../components/layouts/Page";
import Title from "../../../components/layouts/Title";
import { deleteElement, getElements, getReserves } from "../../../database/API";
import getMuiTheme from "../../../theme/TableStyle";
import TableOptions from "../../../components/TableOptions";
import ReservesColumns from "./ReservesColumns";
import DialogAddReserva from "../calendariAdmin/DialogAddReserva";
import { useSnackbar } from "notistack";
import { DialogEliminar } from "../../../components/form/DialogEliminar";

const ReservesAdmin = () => {
    const [loading, setLoading] = useState(true);
    const [reserves, setReserves] = useState([]);
    const [openAdd, setOpenAdd] = useState(false);
    const [update, setUpdate] = useState(0);
    const [openEliminar, setOpenEliminar] = useState();

    const [id, setId] = useState();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const get = async () => {
            const { result } = await getReserves();
            setReserves(result);
            setLoading(false);
        };

        get();
    }, [update]);

    const CustomToolbar = () => {
        return <></>;
    };
    const options = TableOptions(CustomToolbar);

    const eliminar = async () => {
        setLoading(true);
        setOpenEliminar(false);
        await deleteElement("reserves", id);
        setReserves((prev) => prev.filter((reserve) => reserve.id !== id));
        enqueueSnackbar("Reserva eliminada", {
            variant: "success",
        });
        setUpdate((prev) => prev + 1);
        setLoading(false);
    };

    const eliminarOpen = (key) => {
        setId(key);
        setOpenEliminar(true);
    };

    const columns = ReservesColumns(reserves, eliminarOpen);

    return (
        <Page title="Merolla de Berguedà">
            <Box m={5}>
                <Title
                    title="Reserves"
                    button={
                        <IconButton onClick={() => setOpenAdd(true)}>
                            <Add />
                        </IconButton>
                    }
                />
                <Loading loading={loading}>
                    <Box pt={4} spacing={3}>
                        <ThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable data={reserves} columns={columns} options={options} />
                        </ThemeProvider>
                    </Box>
                </Loading>
            </Box>
            <DialogAddReserva open={openAdd} setOpen={setOpenAdd} setUpdate={setUpdate} />
            <DialogEliminar open={openEliminar} setOpen={setOpenEliminar} element={"reserva"} onClick={eliminar} />
        </Page>
    );
};

export default ReservesAdmin;
